module.exports = __webpack_public_path__ + "img/22i.5ec4efb1.png";